import { useEffect, useRef, useState } from "react";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { FormInput } from "../../../shared/components/form-component/form-input";
import { CUSTOM_VALIDATION } from "../../../shared/validation/validation";
import { FormDropdown } from "../../../shared/components/form-component/form-dropdown";
import { HELPER } from "../../../shared/helper/helper";
import { SERVICES } from "../../../core/services/services";
import { Toast } from "primereact/toast";
import { Optional } from "../optional/optional";
import { UserTypes } from "../../constants";

export function MandatesFilter(props) {
  const toast = useRef(null);
  const [loading] = useState(false);
  const [currentIndex] = useState(0);
  const [transaction, setTransaction] = useState({
    accountNumber: "",
    merchant: "",
    startDate: "",
    endDate: "",
    expiryStartDate: "",
    expiryEndDate: "",
    mandateStatus: "",
    mandateReference: "",
  });
  const [transactionError, setTransactionError] = useState({
    accountNumber: null,
    merchant: null,
    startDate: null,
    endDate: null,
    mandateStatus: null,
    mandateReference: null,
    expiryEndDate: null,
    expiryStartDate: null,
  });
  const [merchants, setMerchants] = useState([]);

  const statuses = ["ACTIVATED", "PENDING_ACTIVATION", "DEACTIVATED"];

  useEffect(() => {
    function getMerchants() {
      SERVICES.GET_ALL_MERCHANTS()
        .then((data) => {
          console.log("merchs", data);
          const result = data?.result;
          setMerchants(result);
        })
        .catch((error) => {
          toast.current.show({
            severity: "error",
            summary: "Error getting merchants!",
            detail: HELPER.PROCESS_ERROR(error, "TOAST"),
            life: 10000,
          });
        });
    }
    if (props.userType === UserTypes.Backoffice) {
      getMerchants();
    }
  }, [props.userType]);

  function validateForm(e, name, type, refineName, required) {
    let value = e?.target?.value;
    const isEmpty = CUSTOM_VALIDATION.IS_EMPTY(value);
    const isValidInput = !isEmpty
      ? CUSTOM_VALIDATION.BASIC_VALIDATION(value, type)
      : false;
    if (isValidInput) {
      setTransaction({ ...transaction, [name]: value });
      setTransactionError({ ...transactionError, [name]: null });
    } else {
      let errorMessage =
        required && isEmpty ? `${refineName} is required` : null;
      if (!isValidInput) {
        errorMessage = `${refineName} is invalid`;
      }
      setTransaction({ ...transaction, [name]: null });
      if (isEmpty) {
        setTransactionError({ ...transactionError, [name]: null });
      } else {
        setTransactionError({
          ...transactionError,
          [name]: errorMessage,
        });
      }
    }
  }

  function filterSearch() {
    let payload = {};

    for (const property in transaction) {
      if (transaction[property]) {
        if (property === "facilitatorId") {
          payload[property] = transaction[property]?.paymentFacilitatorId;
        } else payload[property] = transaction[property];
      }
    }

    return payload;
  }

  function cancelModal() {
    props.closeModal();
  }

  const cancelButton = () => {
    if (!loading) {
      return (
        <button onClick={cancelModal} className="secondary-button">
          Cancel
        </button>
      );
    } else {
      return <div />;
    }
  };

  function validateDropdown(e, name) {
    const value = e.target.value;
    if (value) {
      setTransactionError({ ...transactionError, [name]: "" });
      setTransaction({ ...transaction, [name]: value });
    } else {
      let errorMessage = "Select type";
      setTransactionError({ ...transactionError, [name]: errorMessage });
    }
  }

  const submitButton = () => {
    if (!loading) {
      const hasFilters = HELPER.HAS_FILTER_VALUES(transaction);
      const isDisabled = !hasFilters;

      return (
        <button
          onClick={() => {
            if (!isDisabled) {
              props?.searchFunction(filterSearch());
            }
          }}
          className={`primary-button${isDisabled ? " is-disabled" : ""}`}
          disabled={isDisabled}
          aria-disabled={isDisabled}
        >
          Filter
        </button>
      );
    } else {
      return (
        <div className="pull-up-element-2">
          <CustomLoader loadingText="Submitting..." />
        </div>
      );
    }
  };

  const mandateSearchView = () => {
    if (currentIndex) {
      return (
        <div>
          <div className="success-message-btn-container">
            <button
              onClick={() => {
                props.closeModal(true);
              }}
              className="primary-button success-message-btn"
            >
              Close
            </button>
          </div>
        </div>
      );
    } else {
      return <div>{mandateSearchForm()}</div>;
    }
  };

  const mandateSearchForm = () => {
    return (
      <div>
        <div className="custom-modal-title p-text-left">Filter</div>
        <div className="custom-dialog-subtitle-container p-mb-5"></div>
        <div className="p-grid">
          <Optional show={props.userType !== UserTypes.Frontoffice}>
            <div className="p-col-12">
              <FormDropdown
                required={true}
                label="paymentFacilitatorName"
                field="facilitatorId"
                error={transactionError["facilitatorId"]}
                disabled={loading}
                value={transaction["facilitatorId"]}
                fn={validateDropdown}
                options={merchants}
                placeholder="Select payment facilitator"
                filter
                filterBy="paymentFacilitatorName"
              />
            </div>
          </Optional>
          <div className="p-col-12">
            <FormInput
              value={transaction["accountNumber"]}
              required={false}
              field="accountNumber"
              type="NUBAN"
              error={transactionError["accountNumber"]}
              fn={validateForm}
              loading={loading}
              placeholder="Account number"
            />
          </div>
          <div className="p-col-12">
            <FormDropdown
              required={true}
              field="status"
              error={transactionError["status"]}
              disabled={loading}
              value={transaction["status"]}
              fn={validateDropdown}
              options={statuses}
              placeholder="Mandate status"
            />
          </div>
          <div className="p-col-12">
            <FormInput
              value={transaction["reference"]}
              required={false}
              field="reference"
              type="INPUT"
              error={transactionError["reference"]}
              fn={validateForm}
              loading={loading}
              placeholder="Mandate reference"
            />
          </div>
          <div className="p-col-12">
            <label>Creation date:</label>
          </div>
          <div className="p-col-6">
            <label>Start date:</label>
            <FormInput
              inputType="date"
              value={transaction["startDate"]}
              required={false}
              field="startDate"
              type="INPUT"
              error={transactionError["startDate"]}
              fn={validateForm}
              loading={loading}
              placeholder="Start date"
            />
          </div>
          <div className="p-col-6">
            <label>End date:</label>
            <FormInput
              inputType="date"
              value={transaction["endDate"]}
              required={false}
              field="endDate"
              type="INPUT"
              error={transactionError["endDate"]}
              fn={validateForm}
              loading={loading}
              placeholder="End date"
            />
          </div>

          <div className="p-col-12">
            <label>Expiry date:</label>
          </div>
          <div className="p-col-6">
            <label>Start date:</label>
            <FormInput
              inputType="date"
              value={transaction["expiryStartDate"]}
              required={false}
              field="expiryStartDate"
              type="INPUT"
              error={transactionError["expiryStartDate"]}
              fn={validateForm}
              loading={loading}
              placeholder="Start date"
            />
          </div>
          <div className="p-col-6">
            <label>End date:</label>
            <FormInput
              inputType="date"
              value={transaction["expiryEndDate"]}
              required={false}
              field="expiryEndDate"
              type="INPUT"
              error={transactionError["expiryEndDate"]}
              fn={validateForm}
              loading={loading}
              placeholder="End date"
            />
          </div>

          <div className="p-col-12">
            <div className="p-mt-5">
              <div className="p-grid">
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {cancelButton()}
                </div>
                <div className={loading ? "p-col-12" : "p-col-6"}>
                  {submitButton()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <Toast ref={toast} />
      </div>
      <div className="p-pb-2">{mandateSearchView()}</div>
    </div>
  );
}
